import { capitalize, Card, Grid, Slider } from "@mui/material";
import { useEffect, useState } from "react";
import { getCustomReport } from "utils/reportsUtils";

const MDBox = require("components/MDBox").default;
const MDTypography = require("components/MDTypography").default;

const customReports = {
  age: [
    {
      gender: "male",
      type: "range",
      default: [20, 36],
    },
    {
      gender: "female",
      type: "range",
      default: [20, 36],
    },
  ],
};

export const CustomReport = ({ title, type }: { title: string; type: string }) => {
  const [reportRange, setReportRange] = useState(
    customReports[type].reduce((acc, report) => {
      acc[report.gender] = report.default;
      return acc;
    }, {})
  );
  const [results, setResults] = useState({} as { [key: string]: any });

  useEffect(() => {
    getCustomReport("age", 0, reportRange).then((res) => {
      setResults(res);
    });
  }, []);

  const handleSliderChange = (gender, value) => {
    reportRange[gender] = value;
    setReportRange({ ...reportRange });
    getCustomReport("age", 0, reportRange).then((res) => {
      setResults(res);
    });
  };

  const renderChart = (
    <MDBox py={2} pr={2} pl={2}>
      <MDBox display="flex" px={0} pt={0}>
        <MDBox mt={0}>
          {title && <MDTypography variant="h6">{title}</MDTypography>}
          <MDBox mb={2}>
            <MDTypography component="div" variant="button" color="text">
              {""}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Grid container spacing={5} flexDirection="column" mt={2}>
        {customReports[type].map((report, index) => (
          <Grid key={index} container spacing={5} size={12}>
            <Grid size={3}>
              {capitalize(report.gender)}
            </Grid>
            <Grid size={6}>
              <Slider
                onChangeCommitted={(e, v) => handleSliderChange(report.gender, v)}
                defaultValue={report.default}
                valueLabelDisplay="on"
                max={report.default[1]}
                min={report.default[0]}
              />
            </Grid>
            <Grid size={3}>
              {results[index]}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );

  return <Card style={{ width: "100%" }}>{renderChart}</Card>;
};
